export default __webpack_public_path__ + "static/media/Dragon.540e203a.png";